import React from 'react';

const LinkTiles = () => (
  <div className="link-tiles-section">
    <div className="link-tiles-inner">

      <div className="link-tile">
        <h4 className="link-tile-heading">Protect and monitor your network</h4>
        <p className="link-tile-text">
          Would you like to gain deeper insight into your internet-connected
          service? Are you having issues with DDoS attacks? If so contact us by clicking below
        </p>
        <a
          href="mailto:sales@path.net"
          className="link-tile-button"
        >
          CONTACT US
        </a>
      </div>
    </div>
  </div>
);

export default LinkTiles;



// WEBPACK FOOTER //
// ./src/components/home/linkTiles.js